const getIdsFromBuckets = (data = {}, relationProperty = 'productTypeIds') => {
  const {
    searchPublishedContent: {
      rawResults: { aggregations: { [relationProperty]: { buckets } = {} } = {} } = {}
    } = {}
  } = data;
  if (!buckets) return [];
  return buckets.map(({ key } = {}) => key);
};

export default getIdsFromBuckets;
